import redtech from "assets/new-logos/redtech.png";
import abeg from "assets/new-logos/abeg.png";
import unitybank from "assets/new-logos/unity-bank.png";
import tellerone from "assets/new-logos/tellerone.png";
import nova from "assets/new-logos/nova-bank.png";
import piggyvest from "assets/new-logos/piggyvest.png";
import suntrust from "assets/new-logos/suntrust-bank.png";
import pivo from "assets/new-logos/pivo.png";
import brbcapital from "assets/new-logos/brb-capital.png";
import lenco from "assets/new-logos/lenco.png";
import credrails from "assets/new-logos/credrails.png";
import activeedge from "assets/new-logos/activeedge.png";
import dot from "assets/new-logos/dot.png";
import vesti from "assets/new-logos/vesti.png";
import spotflow from "assets/new-logos/spotflow.png";
import evolve from "assets/new-logos/evolve-credit.png";
import linq from "assets/new-logos/linq.png";
import rightcard from "assets/new-logos/right-card.png";
import raven from "assets/new-logos/raven.png";
import accelerex from "assets/new-logos/accelerex.png";
import tix from "assets/new-logos/tix.png";
import earnipay from "assets/new-logos/earnipay.png";
import fcmb from "assets/new-logos/fcmb.png";
import intron from "assets/new-logos/intron.png";
import flex from "assets/new-logos/flex.png";
import novac from "assets/new-logos/novac.png";
import hugo from "assets/new-logos/hugo.png";
import zone from "assets/new-logos/zone.png";
import qore from "assets/new-logos/qore.png";
import amfb from "assets/new-logos/AFMB.png";
import wired_assurance from "assets/new-logos/wired-assurance.png";
import afl from "assets/new-logos/afl.png";
import hammer from "assets/new-logos/Hammergames.png";
import eden from "assets/new-logos/edencore.png";
import transcend from "assets/new-logos/transxend.png";
import veend from "assets/new-logos/vend.png";
import oval from "assets/new-logos/oval.png";
import moneypigeon from "assets/new-logos/moneypigeon.png";
import smileid from "assets/new-logos/smile-id.png";
import sendsprint from "assets/new-logos/sendsprint.png";
import crust from "assets/new-logos/crust.png";
import simplify from "assets/new-logos/simplify.png";
import daccubin from "assets/new-logos/daccubin.png";

const Brands = () => {
  const logos = [
    redtech,
    abeg,
    unitybank,
    tellerone,
    nova,
    piggyvest,
    suntrust,
    pivo,
    brbcapital,
    lenco,
    credrails,
    activeedge,
    dot,
    vesti,
    spotflow,
    evolve,
    linq,
    rightcard,
    raven,
    accelerex,
    tix,
    earnipay,
    intron,
    flex,
    novac,
    hugo,
    zone,
    qore,
    amfb,
    wired_assurance,
    afl,
    hammer,
    eden,
    transcend,
    veend,
    oval,
    moneypigeon,
    smileid,
    sendsprint,
    crust,
    simplify,
    daccubin,
    fcmb,
  ];
  // Split into 3 rows
  const row1 = logos.slice(0, 14);
  const row2 = logos.slice(14, 28);
  const row3 = logos.slice(28);
  return (
    <section className="w-full bg-white pb-20 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 space-y-[4rem]">
        {/* Row 1 → Left */}
        {renderRow(row1, "animate-marqueeLeft")}

        {/* Row 2 → Right */}
        {renderRow(row2, "animate-marqueeRight")}

        {/* Row 3 → Left */}
        {renderRow(row3, "animate-marqueeLeft")}
      </div>
    </section>
  );
};
const renderRow = (row, animation) => (
  <div className="overflow-hidden">
    <div className={`flex w-max ${animation}`}>
      {[...row, ...row].map((logo, i) => (
        <div
          key={i}
          className="flex items-center justify-center h-12 w-[120px] mx-4 shrink-0"
        >
          <img
            src={logo}
            alt="brand"
            className="h-[75px] md:max-h-[82px] w-[70px] md:max-w-[90px] object-contain transition"
          />
        </div>
      ))}
    </div>
  </div>
);
export default Brands;
